module.exports = __webpack_public_path__ + "img/blogpost6.545e7a54.jpg";